var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import { TenantOnboardingStepStates } from "@irati/types";
import { FormattedMessage, injectIntl } from "@irati/utils/lang";
import { Para } from "@irati/ui/src/Labels";
import OnboardingService from "@irati/onboarding/services/onboarding";
import tenantSetupTracking, { ReminderPlatformValues } from "@irati-tracking/tenant-setup";
import tenantReminderImage from "@irati/ui/images/tenant-setup-reminder.png";
import { Card, Content } from "./styled";
var TenantSetupReminder = /** @class */ (function (_super) {
    __extends(TenantSetupReminder, _super);
    function TenantSetupReminder() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {};
        return _this;
    }
    TenantSetupReminder.prototype.componentDidMount = function () {
        var _this = this;
        OnboardingService.getTenantOnboarding().then(function (tenantOnboarding) {
            if ((tenantOnboarding === null || tenantOnboarding === void 0 ? void 0 : tenantOnboarding.enabled) && !(tenantOnboarding === null || tenantOnboarding === void 0 ? void 0 : tenantOnboarding.onboardingFinished)) {
                var remainingSteps = tenantOnboarding.assignedSteps.filter(function (_a) {
                    var state = _a.state;
                    return state !== TenantOnboardingStepStates.Done;
                });
                var remainingStepsCount = remainingSteps.length;
                _this.setState({ tenantOnboarding: tenantOnboarding, remainingStepsCount: remainingStepsCount });
                tenantSetupTracking.viewTenantSetupReminderTile({ platform: ReminderPlatformValues.Mobile });
            }
        }).catch(function () { });
    };
    TenantSetupReminder.prototype.render = function () {
        var _a = this.state, tenantOnboarding = _a.tenantOnboarding, remainingStepsCount = _a.remainingStepsCount;
        var formatMessage = this.props.formatMessage;
        if (!tenantOnboarding)
            return null;
        return (React.createElement(Card, null,
            React.createElement("img", { src: tenantReminderImage, alt: formatMessage({ id: "home.tenantSetupReminder.image.alt" }) }),
            React.createElement(Content, null,
                React.createElement(Para, { large: true, center: true },
                    React.createElement(FormattedMessage, { id: "home.tenantSetupReminder.description" })),
                React.createElement(Para, { bold: true, center: true },
                    React.createElement(FormattedMessage, { id: "home.tenantSetupReminder.missingSteps", values: { stepsCount: remainingStepsCount } })))));
    };
    return TenantSetupReminder;
}(Component));
export default injectIntl(TenantSetupReminder);
